import * as Sentry from '@sentry/nextjs'
import type { UserRole } from '@/types/auth'

interface SentryUserContext {
  id: string
  role?: UserRole | 'anonymous'
}

export function setSentryUserContext(user: SentryUserContext | null): void {
  if (!user) {
    Sentry.setUser(null)
    Sentry.setTag('role', 'anonymous')
    return
  }

  Sentry.setUser({ id: user.id })
  Sentry.setTag('role', user.role ?? 'anonymous')
}
